var map = {
	"./accessory/accessory1.png": "Ivbd",
	"./accessory/accessory2.png": "zt/d",
	"./accessory/accessory3.png": "LVeo",
	"./accessory/accessory4.png": "Lr6l",
	"./accessory/accessory5.png": "GKul",
	"./accessory/accessory6.png": "Lno8",
	"./accessory/accessory7.png": "wMS4",
	"./accessory/accessory8.png": "uHLW",
	"./accessory/accessory_cover.png": "GDsN",
	"./background/background1.png": "bc2/",
	"./background/background2.png": "0lyT",
	"./background/background3.png": "KsDq",
	"./background/background4.png": "f0xL",
	"./background/background_cover.png": "RJXM",
	"./cloth/cloth1.png": "6/oq",
	"./cloth/cloth2.png": "lR10",
	"./cloth/cloth3.png": "EOlO",
	"./cloth/cloth4.png": "rwOs",
	"./cloth/cloth5.png": "v/ZS",
	"./cloth/cloth6.png": "BSQK",
	"./cloth/cloth7.png": "12Gg",
	"./cloth/cloth8.png": "EvzF",
	"./cloth/cloth_cover.png": "zz/7",
	"./face/face1.png": "oBRq",
	"./face/face2.png": "ZkQ4",
	"./face/face3.png": "NuTl",
	"./face/face4.png": "B4ca",
	"./face/face5.png": "PqkN",
	"./face/face6.png": "FSSh",
	"./face/face7.png": "kUjc",
	"./face/face8.png": "r9lc",
	"./face/face_cover.png": "VPbv",
	"./hair/hair1.png": "zTXS",
	"./hair/hair2.png": "L8zA",
	"./hair/hair3.png": "sj2U",
	"./hair/hair4.png": "Azsn",
	"./hair/hair5.png": "oxNP",
	"./hair/hair6.png": "WDkw",
	"./hair/hair7.png": "YOva",
	"./hair/hair8.png": "sZ8V",
	"./hair/hair_cover.png": "W0EQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RklY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button ^\.\/.*\.png$
// module id = RklY
// module chunks = 0